<style>
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Playfair+Display:wght@600&display=swap');

  /* ── Scrollbar ── */
  .sidebar-scroll::-webkit-scrollbar { width: 4px; }
  .sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
  .sidebar-scroll::-webkit-scrollbar-thumb { background: #c8e6c0; border-radius: 4px; }

  /* ── Nav items ── */
  .nav-item {
    position: relative;
    border-radius: 10px;
    margin-bottom: 2px;
    overflow: hidden;
    transition: background 0.2s ease;
  }

  .nav-link {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 11px 14px;
    min-height: 44px;
    border-radius: 10px;
    color: #5a6a55;
    font-size: 14px;
    font-weight: 500;
    font-family: 'DM Sans', sans-serif;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }

  .nav-link::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, #e8f5e0 0%, #f0faea 100%);
    opacity: 0;
    transition: opacity 0.22s ease;
    border-radius: 10px;
  }

  .nav-link:hover::before { opacity: 1; }
  .nav-link:hover { color: #3a7a28; }
  .nav-link:hover .nav-icon { color: #4F873B; transform: scale(1.1); }

  /* Active state */
  .nav-item.active > .nav-link,
  .nav-item.active > a.nav-link {
    background: linear-gradient(135deg, #4F873B 0%, #5fa048 100%);
    color: #fff !important;
    box-shadow: 0 4px 14px rgba(79, 135, 59, 0.35);
  }
  .nav-item.active > .nav-link::before { display: none; }
  .nav-item.active > .nav-link .nav-icon { color: #fff !important; transform: scale(1.05); }
  .nav-item.active > .nav-link .nav-label { color: #fff !important; }

  /* ── Icon ── */
  .nav-icon {
    color: #7a9e72;
    flex-shrink: 0;
    transition: color 0.2s ease, transform 0.2s ease;
    width: 18px;
    height: 18px;
  }

  /* ── Submenu ── */
  .ml-menu {
    list-style: none;
    padding: 4px 0 4px 44px;
    margin: 0;
  }

  .ml-menu li a {
    display: block;
    padding: 9px 12px;
    min-height: 40px;
    border-radius: 8px;
    color: #6b836a;
    font-size: 13px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
    text-decoration: none;
    transition: all 0.18s ease;
    position: relative;
  }

  .ml-menu li a::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 0;
    background: #4F873B;
    border-radius: 2px;
    transition: height 0.2s ease;
  }

  .ml-menu li a:hover { color: #3a7a28; background: #f0faea; }
  .ml-menu li a:hover::before { height: 60%; }
  .ml-menu li.active a { color: #4F873B; font-weight: 600; }
  .ml-menu li.active a::before { height: 60%; }

  /* ── Chevron ── */
  .chevron {
    margin-left: auto;
    width: 14px;
    height: 14px;
    color: #9ab08f;
    transition: transform 0.25s ease, color 0.2s ease;
    flex-shrink: 0;
  }
  .nav-item.active > .nav-link .chevron { transform: rotate(90deg); color: rgba(255,255,255,0.8); }

  /* ── Divider ── */
  .nav-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, #e0eed9, transparent);
    margin: 10px 14px;
  }

  /* ── Section label ── */
  .nav-section-label {
    font-family: 'DM Sans', sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #a8c4a0;
    padding: 8px 14px 4px;
  }

  /* ── Logout ── */
  .logout-link {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 11px 14px;
    min-height: 44px;
    border-radius: 10px;
    color: #b85c5c;
    font-size: 14px;
    font-weight: 500;
    font-family: 'DM Sans', sans-serif;
    cursor: pointer;
    transition: all 0.22s ease;
    text-decoration: none;
  }
  .logout-link:hover { background: #fdf0f0; color: #a84040; }
  .logout-link:hover .logout-icon { transform: translateX(2px); }
  .logout-icon { transition: transform 0.2s ease; color: #c97070; width: 18px; height: 18px; }

  /* ── Cow image ── */
  .cow-card {
    margin: 0 14px 14px;
    border-radius: 14px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 4px 16px rgba(79,135,59,0.12);
  }
  .cow-card img { width: 100%; display: block; object-fit: cover; }
  .cow-card-overlay {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    background: linear-gradient(to top, rgba(30,60,20,0.7), transparent);
    padding: 14px 12px 10px;
  }
  .cow-card-text {
    font-family: 'Playfair Display', serif;
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    opacity: 0.92;
  }

  /* ── Splash ripple ── */
  .splash-ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(79, 135, 59, 0.15);
    transform: scale(0);
    animation: ripple-out 0.6s ease-out forwards;
    pointer-events: none;
  }
  @keyframes ripple-out {
    to { transform: scale(2.5); opacity: 0; }
  }

  /* ── User badge ── */
  .user-badge {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    margin: 0 0 8px;
    background: linear-gradient(135deg, #f0faea 0%, #e8f5e0 100%);
    border-radius: 10px;
    border: 1px solid #d4edca;
  }
  .user-avatar {
    width: 34px; height: 34px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4F873B, #7ab85a);
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 13px; font-weight: 600;
    font-family: 'DM Sans', sans-serif;
    flex-shrink: 0;
  }
  .user-name {
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #3a6b2a;
    line-height: 1.2;
  }
  .user-role {
    font-size: 11px;
    color: #7a9e72;
    font-family: 'DM Sans', sans-serif;
  }

  /* ── Mobile: tighter touch targets ── */
  @media (max-width: 768px) {
    .nav-link {
      padding: 13px 14px;
      font-size: 13.5px;
    }
    .ml-menu {
      padding-left: 38px;
    }
    .ml-menu li a {
      padding: 10px 12px;
      font-size: 13px;
    }
    .user-badge {
      padding: 10px 12px;
    }
  }

  @media (max-width: 480px) {
    .nav-link {
      padding: 12px 10px;
      font-size: 13px;
      gap: 10px;
    }
    .ml-menu {
      padding-left: 32px;
    }
    .ml-menu li a {
      padding: 9px 10px;
      font-size: 12px;
    }
    .user-badge {
      padding: 9px 10px;
    }
    .user-name {
      font-size: 12px;
    }
    .user-role {
      font-size: 10px;
    }
    .user-avatar {
      width: 30px;
      height: 30px;
      font-size: 12px;
    }
    .nav-section-label {
      font-size: 9px;
      padding: 6px 10px 3px;
    }
    .logout-link {
      padding: 12px 10px;
      font-size: 13px;
    }
    .cow-card {
      margin: 0 8px 14px;
    }
  }
</style>

<div>
  <!-- ── Hamburger button ── -->
  <button
    class="sidebar-hamburger"
    (click)="toggleMobileSidebar()"
    [class.open]="mobileOpen"
    aria-label="Toggle menu">
    <span></span><span></span><span></span>
  </button>

  <!-- ── Backdrop overlay ── -->
  <div
    class="sidebar-backdrop"
    [class.show]="mobileOpen"
    (click)="closeMobileSidebar()">
  </div>

  <!-- ── Sidebar panel ── -->
  <aside
    id="leftsidebar"
    class="sidebar bg"
    [class.mobile-open]="mobileOpen"
    (mouseenter)="mouseHover($event)"
    (mouseleave)="mouseOut($event)"
    style="
      width: 260px;
      height: 100vh;
      background: #fafdfa;
      border-right: 1px solid #e4f0e0;
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 0; left: 0;
      z-index: 1000;
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease;
      box-shadow: 2px 0 20px rgba(79,135,59,0.06);
    ">

    <!-- ── Logo ── -->
    <div style="padding: 22px 20px 16px; border-bottom: 1px solid #eaf4e4; flex-shrink: 0;">
      <img
        src="assets/images/mifugo_logo_LANDSCAPE 1.png"
        alt="Mifugo360 Logo"
        style="width: 100%; max-width: 180px; display: block; margin: 0 auto;">
    </div>

    <!-- ── Scrollable body ── -->
    <div
      class="sidebar-scroll"
      style="flex: 1; overflow-y: auto; overflow-x: hidden; padding: 14px 10px 0; -webkit-overflow-scrolling: touch;">

      <!-- User badge -->
      <div class="user-badge" *ngIf="userFullName">
        <div class="user-avatar">{{ userFullName?.charAt(0)?.toUpperCase() }}</div>
        <div>
          <div class="user-name">{{ userFullName }}</div>
          <div class="user-role">Administrator</div>
        </div>
      </div>

      <div class="nav-section-label">Navigation</div>

      <!-- ── Menu list ── -->
      <ul class="list" style="list-style: none; margin: 0; padding: 0;">

        <li
          class="nav-item"
          *ngFor="let sidebarItem of sidebarItems"
          [class.active]="level1Menu === sidebarItem.moduleName && sidebarItem.submenu.length != 0"
          [routerLinkActive]="sidebarItem.submenu.length != 0 ? '' : 'active'">

          <div class="header" *ngIf="sidebarItem.groupTitle === true">
            <div class="nav-divider"></div>
            <div class="nav-section-label">{{ sidebarItem.title | translate }}</div>
          </div>

          <a
            *ngIf="!sidebarItem.groupTitle"
            class="nav-link"
            [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null"
            [ngClass]="[sidebarItem.class]"
            (click)="onNavClick($event, sidebarItem)">
            <i-feather [name]="sidebarItem.icon" class="nav-icon"></i-feather>
            <span
              class="nav-label"
              style="font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 500;">
              {{ sidebarItem.title | translate }}
            </span>
            <span
              *ngIf="sidebarItem.badge != ''"
              [ngClass]="[sidebarItem.badgeClass]"
              style="margin-left: auto; font-size: 11px; background: #4F873B; color: #fff; border-radius: 20px; padding: 1px 7px;">
              {{ sidebarItem.badge }}
            </span>
            <!-- Chevron for items with submenu -->
            <svg
              *ngIf="sidebarItem.submenu.length > 0"
              class="chevron"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </a>

          <!-- ── First level submenu ── -->
          <!-- *ngIf only checks submenu exists; [class.open] drives the animation -->
          <ul
            class="ml-menu"
            *ngIf="sidebarItem.submenu.length > 0"
            [class.open]="level1Menu === sidebarItem.moduleName">
            <li
              *ngFor="let sidebarSubItem of sidebarItem.submenu"
              [ngClass]="level2Menu === sidebarSubItem.moduleName ? 'active' : ''"
              [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'">
              <a
                [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                (click)="callLevel2Toggle($event, sidebarSubItem.moduleName)"
                [ngClass]="[sidebarSubItem.class]">
                {{ sidebarSubItem.title | translate }}
              </a>

              <!-- ── Second level submenu ── -->
              <ul
                class="ml-menu-2"
                *ngIf="sidebarSubItem.submenu.length > 0"
                [class.open]="level2Menu === sidebarSubItem.moduleName"
                style="list-style: none; padding: 4px 0 4px 16px; margin: 0;">
                <li
                  *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu"
                  [ngClass]="level3Menu === sidebarSubsubItem.moduleName ? 'active' : ''"
                  [routerLinkActive]="sidebarSubsubItem.submenu.length > 0 ? '' : 'active'">
                  <a
                    [routerLink]="sidebarSubsubItem.submenu.length > 0 ? null : [sidebarSubsubItem.path]"
                    (click)="callLevel3Toggle($event, sidebarSubsubItem.moduleName)"
                    [ngClass]="[sidebarSubsubItem.class]"
                    style="
                      display: block;
                      padding: 8px 12px;
                      min-height: 38px;
                      border-radius: 7px;
                      color: #7a9e72;
                      font-size: 12.5px;
                      font-family: 'DM Sans', sans-serif;
                      text-decoration: none;
                      transition: all 0.18s ease;
                    ">
                    {{ sidebarSubsubItem.title | translate }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>

        </li>

      </ul>

      <div class="nav-divider" style="margin-top: 10px;"></div>

      <!-- ── Logout ── -->
      <ul style="list-style: none; margin: 0; padding: 0;">
        <li>
          <a (click)="logout()" class="logout-link">
            <svg
              class="logout-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Log Out</span>
          </a>
        </li>
      </ul>

      <!-- ── Cow card ── -->
      <div style="margin-top: 16px;">
        <div class="cow-card">
          <img src="assets/images/cows.png" alt="A herd of cattle at sunset" />
        </div>
      </div>

    </div>
    <!-- /#scrollable body -->

  </aside>
</div>